var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.send()}}},[_c('img',{attrs:{"src":"/img/facebook_icon.svg","alt":""}}),_vm._v(" "),(_vm.buttonText)?_c('span',[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }